import React from 'react';

import {
  calculateNetworkQuality,
  formatNetworkDetails,
  getVideoDeliveryQuality,
} from '../../utils/networkQuality';

const toneClasses = {
  offline: { bar: 'bg-slate-400', text: 'text-slate-300' },
  checking: { bar: 'bg-sky-400', text: 'text-sky-300' },
  excellent: { bar: 'bg-emerald-400', text: 'text-emerald-300' },
  good: { bar: 'bg-green-400', text: 'text-green-300' },
  fair: { bar: 'bg-amber-400', text: 'text-amber-300' },
  poor: { bar: 'bg-red-400', text: 'text-red-300' },
};

const NetworkStrengthChecker = ({ metrics = {} }) => {
  const quality = calculateNetworkQuality(metrics);
  const classes = toneClasses[quality.tone] || toneClasses.offline;
  const activeBars = quality.score === 0
    ? 0
    : Math.max(1, Math.ceil((quality.score / 100) * 4));
  const detail = formatNetworkDetails(metrics);
  const videoQuality = getVideoDeliveryQuality(metrics);
  const summary = [
    quality.label,
    videoQuality?.label,
    detail,
  ].filter(Boolean).join(' · ');

  return (
    <div
      className="flex min-w-0 items-center gap-1.5"
      title={summary}
      aria-label={`Network and video ${summary}`}
    >
      <div className="flex h-4 shrink-0 items-end gap-[2px]" aria-hidden="true">
        {[4, 7, 10, 14].map((height, index) => (
          <span
            key={height}
            className={`w-[3px] rounded-sm ${
              index < activeBars ? classes.bar : 'bg-white/25'
            }`}
            style={{ height }}
          />
        ))}
      </div>
      <span className={`hidden text-[10px] font-semibold md:inline ${classes.text}`}>
        {quality.label}
      </span>
      {videoQuality && (
        <span className="hidden text-[10px] font-semibold text-sky-200 lg:inline">
          {videoQuality.label}
        </span>
      )}
      {detail && (
        <span className="hidden max-w-[150px] truncate text-[10px] text-slate-300 xl:inline">
          {detail}
        </span>
      )}
    </div>
  );
};

export default NetworkStrengthChecker;
